export default "__VITE_ASSET__1e2c48ef__"